import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import routes_web from '../../../connections/routes_web';

export function useReturnToPrevious() {
  const navigate = useNavigate();
  const location = useLocation();

  return () => {
    const from = location.state?.from;
    if (typeof from === 'string' && from.startsWith('/')) {
      navigate(from);
      return;
    }
    const idx = window.history.state?.idx;
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1);
      return;
    }
    navigate(routes_web.accounts_home);
  };
}

const ViewBackHeader = ({ title, onBack }) => (
  <button
    type="button"
    onClick={onBack}
    className="mb-4 flex items-center gap-1 text-gray-900 hover:text-gray-600 transition-colors"
  >
    <ChevronLeft className="h-5 w-5" strokeWidth={2} />
    <span className="text-lg font-semibold">{title}</span>
  </button>
);

export default ViewBackHeader;
